export function fetchRequest(
  url: string,
  options: RequestInit
): Promise<Response> {
  return window.fetch(url, options);
}
